$color_1: #777;
$color_2: #fff;
$secondaryBgColor: #ddd;
$primaryBgColor: var(--bs-primary);

.clearfixProgress {
  &:after {
    clear: both;
    content: "";
    display: block;
    height: 0;
  }
}
.arrowSteps {
  .step {
    font-size: 14px;
    text-align: center;
    color: $color_1;
    cursor: pointer;
    margin: 0 1px 0 0;
    padding: 10px 10px 10px 25px;
    float: left;
    position: relative;
    background-color: $secondaryBgColor;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    a {
      color: $color_1;
      text-decoration: none;
    }
    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: -17px;
      width: 0;
      height: 0;
      border-top: 19px solid transparent;
      border-bottom: 17px solid transparent;
      border-left: 17px solid $secondaryBgColor;
      z-index: 2;
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: -17px;
      width: 0;
      height: 0;
      border-top: 19px solid transparent;
      border-bottom: 17px solid transparent;
      border-left: 17px solid $secondaryBgColor;
      z-index: 2;
      right: auto;
      left: 0;
      border-left: 17px solid $color_2;
      z-index: 0;
    }
    &:first-child {
      &:before {
        border: none;
      }
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    span {
      position: relative;
    }
  }
  .step.current {
    color: $color_2;
    background-color: $primaryBgColor;
    &:after {
      border-left: 17px solid $primaryBgColor;
    }
  }
  .step.done {
    color: $color_2;
    background-color: $primaryBgColor;
    &:after {
      border-left: 17px solid $primaryBgColor;
    }
  }
  .step.disabled {
    cursor: initial;
  }
}
*.arrowSteps {
  .step.done {
    span {
      &:before {
        opacity: 1;
        content: "";
        position: absolute;
        top: -2px;
        left: -10px;
        font-size: 11px;
        line-height: 21px;
      }
    }
  }
}
